// extracted by mini-css-extract-plugin
module.exports = {"star":"Star_star__xSs55","empty":"Star_empty__2yaZD"};